import { createSelector } from 'reselect';
import { getState } from './state';

export const getSettingsSlice = createSelector([getState], slice => {
  return slice.settings;
});

export const getIsSoundDisabled = createSelector(getSettingsSlice, state => {
  return state?.disableSounds ?? false;
});

export const getIsOnlyMyWatchers = createSelector(getSettingsSlice, state => {
  return state?.onlyWatch ?? false;
});

export const getMenuSettingsStatus = createSelector(
  getSettingsSlice,
  state => {
    return state?.status ?? 'uninitialized';
  }
);

export const getHasLegacyNotes = createSelector(getSettingsSlice, state => {
  return state?.hasLegacyNotes ?? false;
});

export const getHasLegacyChat = createSelector(getSettingsSlice, state => {
  return state?.hasLegacyChat ?? false;
});
